<template>
    <div class="general-modal">
        <BaseModal :padding="isMobileOrTablet ? MODAL_PADDING_MOBILE : MODAL_PADDING_DESKTOP"
                   maxWidth="500px"
                   maxHeight="500px"
                   useContentFullHeight
                   useClickOutsideClose
                   @close="handleClose">
            <template #header />
            <template #content>
                <div class="general-modal__content general-modal__content--justify-center">
                    <div class="general-modal__image">
                        <img :src="WALLET_CONNECT_SUCCESS"
                             :alt="getTrans('quests-dashboard.walletConnectedSuccessfullyImage', 'Wallet connected successfully image')">
                    </div>
                    <div class="general-modal__title">
                        <Translate translationKey="quests-dashboard.walletConnectedSuccessfully"
                                   fallback="Wallet connected successfully!" />
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="general-modal__actions">
                    <span class="general-modal__action general-modal__action--confirm">
                        <BaseButton :variant="ButtonVariantEnum.SECONDARY"
                                    @click="redirectToApp">
                            <Translate translationKey="quests-dashboard.backToApp"
                                       fallback="Back to App" />
                        </BaseButton>
                    </span>
                </div>
            </template>
        </BaseModal>
    </div>
</template>

<script setup lang="ts">
    import BaseModal from '@/js/components/BaseModal.vue';
    import { ModalEnum, useModalStore } from '@/js/store/quests/game/modules/ModalStore';
    import { useModalActive } from '@/js/composables/useModalActive';
    import { useDeviceSize } from '@/js/composables/useDeviceSize';
    import BaseButton from '@/js/components/BaseButton.vue';
    import { ButtonVariantEnum } from '@/js/types/components/ButtonVariantEnum';
    import { MODAL_PADDING_DESKTOP, MODAL_PADDING_MOBILE } from '@/js/quests/global/constants/modal';
    import { WALLET_CONNECT_SUCCESS } from '@/js/constants/assets';
    import { getTrans } from '@/js/helpers/getTrans';
    import Translate from '@/js/helpers/Translate.vue';

    const modalStore = useModalStore();
    const { isMobileOrTablet } = useDeviceSize();

    const handleClose = () => {
        modalStore.toggleModal(ModalEnum.RETURN_TO_MOBILE_APP, false);
        modalStore.resolveReturnToMobileAppResolver();
    };

    const redirectToApp = () => {
        handleClose();
        window.location.href = 'bitdegree://wallet-connect-success';
    };

    useModalActive();
</script>

<style scoped lang="scss">
@use "@/js/quests/dashboard/sass/mixins/_modal" as modalMixins;
@use "@/sass/design-system/fonts" as fonts;

.general-modal {
    @include modalMixins.modal;

    &__image {
        img {
            width: 175px;
            height: 190px;
        }
    }

    &__content {
        font-family: fonts.$font-quicksand;
    }
}
</style>
